var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{attrs:{"active":_vm.selected},on:{"click":function($event){return _vm.$emit('selected', _vm.item)}}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }